import PropTypes from 'prop-types'
import React from 'react'

import { isEmpty } from '../../utilities/GeneralUtils'
import AIconAction from '../link/AIconAction'
import AExpandPanelCustom from './AExpandPanelCustom'

/**
 * @author Amarjeet Lamba <Amarjeet.Lamba@activenetwork.com>
 *
 * SimpleExpandPanel description
 * @returns {element} SimpleExpandPanel
 *
 */
const SimpleExpandPanel = ({
  headerOpenText = '',
  headerCloseText = '',
  defaultOpen = false,
  onToggle,
  content,
  cmpId = null,
}) => {
  const getOpenHeader = function () {
    return (
      <AIconAction
        faStyle={'fa-chevron-down'}
        onClick={() => {
          // do nothing
        }}
        label={headerOpenText}
        isShowAsLink
        cmpControlsId={cmpId}
        cmpExpanded={false}
        asSpan
      />
    )
  }
  const getClosedHeader = function () {
    let text = headerCloseText
    if (isEmpty(text)) {
      text = headerOpenText
    }

    return (
      <AIconAction
        faStyle={'fa-chevron-up'}
        onClick={() => {
          // do nothing
        }}
        label={text}
        isShowAsLink
        cmpControlsId={cmpId}
        cmpExpanded={true}
        asSpan
      />
    )
  }

  return (
    <AExpandPanelCustom
      defaultOpen={defaultOpen}
      headerOpen={getOpenHeader()}
      headerClose={getClosedHeader()}
      hasBorder={false}
      hasMargin={false}
      hasPadding={false}
      onToggle={onToggle}
      cmpId={cmpId}
    >
      {content}
    </AExpandPanelCustom>
  )
}

SimpleExpandPanel.propTypes = {
  headerOpenText: PropTypes.string.isRequired,
  headerCloseText: PropTypes.string,
  content: PropTypes.node,
  defaultOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  cmpId: PropTypes.string,
}

export default SimpleExpandPanel
